import CampaignModel, { AudienceSettingsType, CampaignType, ObjectRelationshipTriggerType } from 'cio/models/campaign';
import ObjectTypeModel from 'cio/models/object-type';
import { findOperator } from 'cio/utils/conditions-operators';
import { getFullAttributeValue } from 'cio/utils/conditions/attribute-value';
import { isEmpty } from '@ember/utils';
import { ConditionType } from '../condition-types';

export function firstAttributeConditionSentence(
  attributes: CampaignModel['relationshipAttributeTriggers'] | CampaignModel['objectAttributeTriggers'],
  objectType: ObjectTypeModel | null,
  useUpdateLabel?: boolean,
) {
  if (objectType == null || attributes == null) {
    return '';
  }
  let [condition] = attributes;
  let operator = findOperator(condition.operator);
  if (operator != null) {
    let sentence = `${condition.field} ${operator[useUpdateLabel === true ? 'updateLabel' : 'label']}`;
    let value = getFullAttributeValue(condition);
    if (!isEmpty(value)) {
      sentence = `${sentence} ${value}`;
    }
    return sentence;
  }
  return '';
}

export function getAudienceSummaryText(
  {
    audience,
    type,
    objectCampaign,
    relationshipCampaign,
  }: Pick<CampaignModel, 'type' | 'audience' | 'objectCampaign' | 'relationshipCampaign'>,
  objectType: ObjectTypeModel | null,
  skipConditionsText = false,
): string | null {
  if (audience != null && objectType != null) {
    let campaignTypeData: any = null;
    if (type === CampaignType.Object) {
      campaignTypeData = objectCampaign;
    } else if (type === CampaignType.ObjectRelationship) {
      campaignTypeData = relationshipCampaign;
    }

    if (campaignTypeData != null) {
      if (type !== CampaignType.Object && audience.type === AudienceSettingsType.self) {
        if (campaignTypeData.type === ObjectRelationshipTriggerType.Created) {
          return `The person added to the ${objectType.singularName.toLowerCase()} will enter the campaign.`;
        }
        if (campaignTypeData.type === ObjectRelationshipTriggerType.Updated) {
          return `The person whose relationship with the ${objectType.singularName.toLowerCase()} was changed will enter the campaign.`;
        } else if (campaignTypeData.type === ObjectRelationshipTriggerType.Deleted) {
          return `The person removed from the ${objectType.singularName.toLowerCase()} will enter the campaign.`;
        }
      } else if (audience.type === AudienceSettingsType.related) {
        return `Each person related to the ${objectType.singularName.toLowerCase()} will enter the campaign.`;
      } else if (audience.type === AudienceSettingsType.filtered) {
        let summary = `People related to the ${objectType.singularName.toLowerCase()} will enter the campaign if`;
        if (skipConditionsText) {
          return `${summary} they match these conditions:`;
        }
        let conditions = [...(audience.personFilters ?? []), ...(audience.relationshipFilters ?? [])];
        let count = conditions.length;
        if (count === 1) {
          let sentence = firstAttributeConditionSentence(conditions, objectType);
          if (sentence != null) {
            if (conditions[0].type === ConditionType.RelationshipAttribute) {
              return `${summary} their relationship's ${sentence}.`;
            }
            return `${summary} person's ${sentence}.`;
          }
        }
        return `${summary} they meet ${count} conditions.`;
      }
    }
  }
  return null;
}
